//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    routeSource: {
      type: Object,
      default: null
    }
  },
  computed: {
    overdueTechnicalTask: function () {
      return this.getChildrenBlockByType('overdueTechnicalTask')
    },
    overdueNonTechnicalTask: function () {
      return this.getChildrenBlockByType('overdueNonTechnicalTask')
    },
    overdueTotal: function () {
      return this.getChildrenBlockByType('overdueTotal')
    },
    overdueTotalNoActualization: function () {
      return this.getChildrenBlockByType('overdueTotalNoActualization')
    }
  },
  methods: {
    getChildrenBlockByType: function (type) {
      const routeSourceChildrens = this.routeSource && this.routeSource.compound && this.routeSource.compound.flatMap(compound => compound.children)
      return routeSourceChildrens && routeSourceChildrens.find(children => children.type === type)
    }
  }
}
